import Vue from 'vue';
import { library, config } from '@fortawesome/fontawesome-svg-core';

import {
  faCalendarDay,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronUp,
  faChevronRight,
  faChevronLeft,
  faCloudUploadAlt,
  faDownload,
  faExclamationTriangle,
  faExclamationCircle,
  faExternalLinkAlt,
  faGripLines,
  faPlus,
  faQuestionCircle,
  faSearch,
  faSearchPlus,
  faTasks,
  faTimes,
  faSignOutAlt,
  faMinus,
  faBell,
  faThumbtack,
  faHeart,
  faGlobeAmericas,
  faLock,
  faSpinner,
  faUserCircle,
  faPlay,
  faArrowRight,
  faTrash,
  faShoppingCart,
  faUser,
  faBars,
  faUserFriends,
  faShieldAlt,
  faTag,
  faStar,
  faGlobe,
  faLaptopCode,
  faExchangeAlt,
  faList,
  faAward,
  faCogs,
  faEnvelope,
} from '@fortawesome/free-solid-svg-icons';
import {
  faArrowAltCircleDown as farArrowAltCircleDown,
  faClock,
  faCopy,
  faHeart as farHeart,
} from '@fortawesome/free-regular-svg-icons';
import {
  faFacebook,
  faTwitter,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
  farArrowAltCircleDown,
  faBars,
  faCalendarDay,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronUp,
  faChevronRight,
  faChevronLeft,
  faCloudUploadAlt,
  faDownload,
  faExclamationTriangle,
  faExclamationCircle,
  faExternalLinkAlt,
  faGripLines,
  faPlay,
  faPlus,
  faQuestionCircle,
  faSearch,
  faSearchPlus,
  faTasks,
  faTimes,
  faClock,
  faSignOutAlt,
  faMinus,
  faCopy,
  faBell,
  faThumbtack,
  faHeart,
  farHeart,
  faGlobeAmericas,
  faLock,
  faSpinner,
  faUserCircle,
  faUser,
  faArrowRight,
  faTrash,
  faShoppingCart,
  faBell,
  faUserFriends,
  faShieldAlt,
  faTag,
  faStar,
  faGlobe,
  faLaptopCode,
  faExchangeAlt,
  faList,
  faAward,
  faCogs,
  faEnvelope,
  faFacebook,
  faTwitter,
  faLinkedin,
);

config.autoAddCss = false;

Vue.component('font-awesome-icon', FontAwesomeIcon);
